document.addEventListener('DOMContentLoaded', () => {
    const topLogoUpperTxt = document.querySelector('.t-mv__logo--upper-txt');
    const topLogoMark = document.querySelector('.t-mv__logo--mark');
    const topLogoLowerTxt = document.querySelector('.t-mv__logo--lower-txt');
    const headerClass = document.querySelector('.js-header');
    const donationClass = document.querySelector('.js-donation');

    let scrollTimeout = null; // スクロールタイマーのための変数

    // // スクロールを禁止にする関数
    // function disableScroll(event) {
    //     event.preventDefault();
    // }
    // // スクロール禁止
    // document.addEventListener('touchmove', disableScroll, { passive: false });
    // document.addEventListener('mousewheel', disableScroll, { passive: false });
    
    setTimeout(() => {
        topLogoUpperTxt.classList.add('is-show');
        topLogoMark.classList.add('is-show');
    }, 1000); // +1000のアニメーション
    setTimeout(() => {
        topLogoUpperTxt.classList.remove('is-show');
    }, 3500); // +1000のアニメーション
    setTimeout(() => {
        topLogoMark.classList.add('u-logo-move-up');
    }, 5500);
    setTimeout(() => {
        topLogoLowerTxt.classList.add('is-show');
    }, 7000);
    setTimeout(() => {
        donationClass.classList.add('is-show');
        // // スクロール禁止解除
        // document.removeEventListener('touchmove', disableScroll, { passive: false });
        // document.removeEventListener('mousewheel', disableScroll, { passive: false });
    }, 9000);
    

    // スクロールでヘッダー表示
    let lastScrollTop = 0; // 最後のスクロール位置を保持する変数
    document.addEventListener('scroll', () => {
        const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

        // 下方向へのスクロールを検出
        if (currentScrollTop > lastScrollTop) {
            headerClass.classList.add('is-show');
        }
        // // 上方向へのスクロールを検出
        // if (currentScrollTop < lastScrollTop) {
        //     headerClass.classList.remove('is-show');
        // }

        // 最後のスクロール位置を更新
        lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;

        let scrollTimer = 50;
        if(window.innerWidth <= 768){
            // スマホの場合ウィンドウバーの影響でアニメーションが飛ぶ場合があるため
            scrollTimer = 500;
        }
        // 寄付ボタン遅延追従
        // 既存のタイムアウトをクリア
        if (scrollTimeout) {
            clearTimeout(scrollTimeout);
        }
        // スクロールイベント後に実行
        scrollTimeout = setTimeout(function() {
            donationClass.style.transform = 'translateY(' + currentScrollTop + 'px)';
        }, scrollTimer);
    });

});